import {
  RoutesRegionalAreasComponents,
  RoutesRegionalAreasObject,
} from '@/plugins/1.router/routes/regional/areas'
import {
  RoutesRegionalUpdatesComponents,
  RoutesRegionalUpdatesObject,
} from '@/plugins/1.router/routes/regional/updates'

export const RoutesRegional = [
  ...RoutesRegionalAreasObject,
  ...RoutesRegionalUpdatesObject,
]

export default [
  ...RoutesRegionalAreasComponents,
  ...RoutesRegionalUpdatesComponents,
]
